/* unplugin-vue-components disabled */import script from "./ecommerceProfitCalculator.vue?vue&type=script&setup=true&lang=js"
export * from "./ecommerceProfitCalculator.vue?vue&type=script&setup=true&lang=js"

import "./ecommerceProfitCalculator.vue?vue&type=style&index=0&id=7dfbd0ca&scoped=true&lang=css"

import exportComponent from "/home/kenandlyhael/www/salehoo-mi/salehoo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dfbd0ca"]])

export default __exports__